<template>
    <BootstrapModal
        ref="embedModalRef"
        modalId="embed-modal"
        modalSize="l"
        :title="mainTitle ? mainTitle : 'Embedded Content'"
        :closeText="'Close'"
        :loading="isLoading"
    >
        <template #left-icon>
            <svg
                @click="showPopup = true"
                width="1.5rem"
                height="1.5rem"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16.5 2.25C14.7051 2.25 13.25 3.70507 13.25 5.5C13.25 5.69591 13.2673 5.88776 13.3006 6.07412L8.56991 9.38558C8.54587 9.4024 8.52312 9.42038 8.50168 9.43939C7.94993 9.00747 7.25503 8.75 6.5 8.75C4.70507 8.75 3.25 10.2051 3.25 12C3.25 13.7949 4.70507 15.25 6.5 15.25C7.25503 15.25 7.94993 14.9925 8.50168 14.5606C8.52312 14.5796 8.54587 14.5976 8.56991 14.6144L13.3006 17.9259C13.2673 18.1122 13.25 18.3041 13.25 18.5C13.25 20.2949 14.7051 21.75 16.5 21.75C18.2949 21.75 19.75 20.2949 19.75 18.5C19.75 16.7051 18.2949 15.25 16.5 15.25C15.4472 15.25 14.5113 15.7506 13.9174 16.5267L9.43806 13.3911C9.63809 12.9694 9.75 12.4978 9.75 12C9.75 11.5022 9.63809 11.0306 9.43806 10.6089L13.9174 7.4733C14.5113 8.24942 15.4472 8.75 16.5 8.75C18.2949 8.75 19.75 7.29493 19.75 5.5C19.75 3.70507 18.2949 2.25 16.5 2.25ZM14.75 5.5C14.75 4.5335 15.5335 3.75 16.5 3.75C17.4665 3.75 18.25 4.5335 18.25 5.5C18.25 6.4665 17.4665 7.25 16.5 7.25C15.5335 7.25 14.75 6.4665 14.75 5.5ZM6.5 10.25C5.5335 10.25 4.75 11.0335 4.75 12C4.75 12.9665 5.5335 13.75 6.5 13.75C7.4665 13.75 8.25 12.9665 8.25 12C8.25 11.0335 7.4665 10.25 6.5 10.25ZM16.5 16.75C15.5335 16.75 14.75 17.5335 14.75 18.5C14.75 19.4665 15.5335 20.25 16.5 20.25C17.4665 20.25 18.25 19.4665 18.25 18.5C18.25 17.5335 17.4665 16.75 16.5 16.75Z"
                        fill="#999"
                    ></path>
                </g>
            </svg>

        </template>
        <template #body>
            <div class="text-center ">
                <!-- Cover Image -->
                <div class="text-center mb-3">
                    <!-- Show iframe when in 'streaming-and-preview' OR 'preview-only' (by display_mode) and previewEmbed exists -->
                    <div v-if="((musicOption && (musicOption.display_mode === 'streaming-and-preview' || musicOption.display_mode === 'preview-only')))
            && (platform || '').toLowerCase() === (mainSource || '').toLowerCase()
            && previewEmbed">

                        <img
                            v-if="!['soundcloud', 'deezer'].includes(platform.toLowerCase()) && !(musicOption && musicOption.display_mode === 'preview-only')"
                            :src="mainCoverImageUrl()"
                            alt="Music preview placeholder"
                            class="img-fluid w-100"
                        />
                        <iframe
                            :src="previewEmbed"
                            width="100%"
                            :height="platform.toLowerCase() === 'soundcloud' ? 300 : (platform.toLowerCase() === 'deezer' ? 200 : '41')"
                            frameborder="0"
                            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                            loading="lazy"
                            style="border-radius: 12px;"
                        ></iframe>

                    </div>
                    <!-- Fallback to image if not preview mode -->
                    <a
                        v-else-if="(mainCoverImage && mainUrl) && !(musicOption && musicOption.display_mode === 'preview-only')"
                        :href="mainUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="d-inline-block mb-3"
                    >
                        <img
                            :src="mainCoverImageUrl()"
                            alt="Album Cover"
                            style="max-width: 300px; border-radius: 16px; display: inline-block;"
                        />
                    </a>

                </div>
                <!-- Title and Artist -->
                <h4 class="fw-bold" v-if="!(musicOption && musicOption.display_mode === 'preview-only')">{{ mainTitle }}</h4>
                <p class="text-muted mb-4" v-if="!(musicOption && musicOption.display_mode === 'preview-only') && mainArtist">{{ mainArtist }}</p>

                <!-- "Listen on" label -->
                <p class="text-muted text-uppercase fw-semibold small mb-3" v-if="!(musicOption && musicOption.display_mode === 'preview-only')">Listen on</p>

                <!-- List of services -->
                <div class="d-flex flex-column gap-2" v-if="!(musicOption && musicOption.display_mode === 'preview-only')">
                    <a
                        v-for="service in streamingServices.filter(s => s.url)"
                        :key="service.id"
                        :href="service.url"
                        target="_blank"
                        class="music-service-item d-flex align-items-center justify-content-between p-3 text-decoration-none text-dark"
                    >
                        <div class="d-flex align-items-center gap-2">
                            <span v-html="service.icon" style="width: 24px;"></span>
                            <strong>{{ service.source }}</strong>
                        </div>
                        <!-- External icon -->
                        <span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#8E8E93"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            >
                              <path d="M18 13v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                              <polyline points="15 3 21 3 21 9" />
                              <line x1="10" y1="14" x2="21" y2="3" />
                            </svg>
                        </span>
                    </a>

                </div>
            </div>
        </template>

    </BootstrapModal>

    <SharePopup :show="showPopup"
                :username="username"
                :urlName="urlName"
                :shortCode="shortCode"
                @close="showPopup = false" />
</template>
<script>
import BootstrapModal from "@/Components/BootstrapModal.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import SharePopup from "@/Components/SharePopup.vue";
import { buildLinkAssetUrl } from "@/utils/assetUrls.js";

export default {
    name: 'MusicEmbedModal',
    components: {
        SharePopup,
        BootstrapModal,
        FontAwesomeIcon,
    },
    data() {
        return {
            showPopup: false,
            embedSrc: null,
            shortCode: "",
            isLoading: false,
            embedTitle: "Embedded Player",
            mainCoverImage: null,
            mainTitle: '',
            mainArtist: '',
            mainUrl: '',
            previewEmbed: '',
            musicOption: '',
            platform: {},
            mainSource: '',
            streamingServices: [],
        };
    },
    props: ["item", "username", "urlName", 'DoBucket', 'DoEndpoint'],
    methods: {
        closeModalContactDetails() {
            this.$refs.embedModalRef.closeModal("embed-modal");
        },
        mainCoverImageUrl() {
            return buildLinkAssetUrl(
                this.DoEndpoint,
                this.DoBucket,
                this.mainCoverImage,
            );
        },
        buildSoundCloudEmbed(trackUrl) {
            if (!trackUrl) return '';
            const base = 'https://w.soundcloud.com/player/';
            const params = new URLSearchParams({
                url: trackUrl,
                color: '#ff5500',
                auto_play: 'false',
                hide_related: 'false',
                show_comments: 'true',
                show_user: 'true',
                show_reposts: 'false',
                show_teaser: 'true',
                visual: 'true',
            });
            return `${base}?${params.toString()}`;
        },
        buildDeezerEmbed(contentUrl, fallback = '') {
            if (!contentUrl) return fallback || '';
            try {
                const m = contentUrl.match(/deezer\.com\/(?:(?:[a-z]{2}\/)?)(track|album|playlist|artist)\/(\d+)/i);
                if (m) {
                    const type = (m[1] || 'track').toLowerCase();
                    const id = m[2];
                    return `https://widget.deezer.com/widget/dark/${type}/${id}`;
                }
            } catch (e) {
                // ignore
            }
            // If we can't parse, return fallback or original URL (backend may provide an embeddable URL)
            return fallback || contentUrl;
        },
        async openEmbedModalForMusic(link) {
            this.isLoading = true;
            // Reset states
            this.mainCoverImage = null;
            this.mainTitle = '';
            this.mainArtist = '';
            this.streamingServices = [];
            this.mainUrl = '';
            this.previewEmbed = '';
            this.mainSource = '';
            this.platform = link.platform || '';
            this.musicOption = link.options?.music || '';
            this.shortCode = link.short_code;

            // Show the modal
            this.$refs.embedModalRef.showModal("embed-modal");

            try {
                const response = await axios.get(`/music/public/${link.id}`);
                const data = response.data;

                this.streamingServices = data.streaming_services || [];
                this.mainCoverImage = link.file || '';
                this.mainTitle = data.title || '';
                this.mainArtist = data.artist || '';
                this.mainUrl = data.main_url || '';
                this.mainSource = data.platform || '';

                // ✅ Only show preview embed if source == platform
                const isSamePlatform = (this.platform || '').toLowerCase() === (this.mainSource || '').toLowerCase();

                // Default preview from API
                let preview = isSamePlatform && data.preview ? data.preview : '';

                // If SoundCloud in streaming-and-preview, force SoundCloud widget URL with our params
                const isSoundCloud = (this.platform || '').toLowerCase() === 'soundcloud';
                const isDeezer = (this.platform || '').toLowerCase() === 'deezer';
                const isStreamingAndPreview = this.musicOption && this.musicOption.display_mode === 'streaming-and-preview';
                const isPreviewOnly = this.musicOption && this.musicOption.display_mode === 'preview-only';
                if (isSamePlatform && isSoundCloud && (isStreamingAndPreview || isPreviewOnly)) {
                    // Try to find the soundcloud service URL from the list
                    const scService = (this.streamingServices || []).find(s => (s.source || '').toLowerCase() === 'soundcloud');
                    const trackUrl = scService?.url || this.mainUrl || preview || '';
                    const scEmbed = this.buildSoundCloudEmbed(trackUrl);
                    if (scEmbed) preview = scEmbed;
                }

                // Deezer embed (same behavior as DeezerCard)
                if (isSamePlatform && isDeezer && (isStreamingAndPreview || isPreviewOnly)) {
                    const dzService = (this.streamingServices || []).find(s => (s.source || '').toLowerCase() === 'deezer');
                    const contentUrl = dzService?.url || this.mainUrl || preview || '';
                    const dzEmbed = this.buildDeezerEmbed(contentUrl, preview);
                    if (dzEmbed) preview = dzEmbed;
                }

                this.previewEmbed = preview;

            } catch (error) {
                console.error("Failed to load music info:", error);
            } finally {
                this.isLoading = false;
            }
        }


    }
};
</script>
<style scoped>
.music-service-item {
    transition: background-color 0.2s ease, transform 0.2s ease;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
}

.music-service-item:hover {
    background-color: #f9f9f9;
    transform: translateY(-1px);
    cursor: pointer;
}

</style>
